import { css } from '@emotion/core'

export const plain = ({
  theme: {
    components: { storeListFilter }
  }
}) => css`
  .list-item {
    &:hover {
      color: ${storeListFilter.title.hoverColor};
    }
  }
  .title {
    padding-bottom: 0.6rem;
    margin-left: 0.3rem;
    text-transform: uppercase;
    font-weight: 600;
    color: ${storeListFilter.title.color};
  }

  .options {
    display: flex;
    flex: 1;
    margin-bottom: 0.5rem;
  }

  .clear-label {
    flex: 1;
    text-align: right;
    text-transform: lowercase;
    a,
    button {
      color: ${storeListFilter.clear.color};
      text-decoration: none;
      border: none;
      background: none;
      text-transform: lowercase;
      font-size: 0.8rem;

      &:hover {
        color: ${storeListFilter.clear.hover.color};
      }
    }
  }

  .selected-items {
    flex: 1;
    font-size: 0.8rem;
    color: ${storeListFilter.selectedItems.color};
  }

  .list {
    max-height: 300px;
    list-style-type: none;
    list-style: none;
    overflow: auto;
    &::-webkit-scrollbar {
      width: ${storeListFilter.scrollbar.width};
      height: 0;
    }

    &::-webkit-scrollbar-thumb {
      background: ${storeListFilter.scrollbar.thumb.color};
    }

    &::-webkit-scrollbar-track {
      background: ${storeListFilter.scrollbar.track.color};
    }
  }

  .list-item {
    cursor: pointer;
  }
`

export default plain
